// extracted by mini-css-extract-plugin
export default {"Container":"UserInfo_Container__PV9IF","Logo":"UserInfo_Logo__PWU6+","NameAndInfo":"UserInfo_NameAndInfo__cmLq+","Name":"UserInfo_Name__6bvrB","Info":"UserInfo_Info__Te26e"};